import { Box, Typography } from "@mui/material";
import { MprcIconButtonDropdown } from "components";
import { MprcDropdownBuildGroupedItems, MprcDropdownItems } from "components/MprcIconButtonDropdown";
import { MprcRequestSnackbarErrorReport } from "components/MprcRequestErrorReport";
import { MprcCardFilterBox } from "components/filter/MprcCardFilterBox";
import { IconFilter, IconUpload } from "components/icons";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { AdvancedFilter, IAdvFilterCommand, IAdvFilterParams } from "views/general/AdvancedFilter";

type MenuImportOptions = "importFile" | "importList" | "clear";

interface IProps {
    importedFile: boolean;
    filterCommands: IAdvFilterCommand[];
    filterOptions: IAdvFilterParams<any>;
    additionalFilterButtons?: React.ReactNode[];
    onFilterChange: (filter: IAdvFilterParams<any>) => void;
    onImportedFile: (option: MenuImportOptions) => void;
}

export const BatchEditSearchUsersFilter: React.FC<IProps> = ({ filterOptions, filterCommands, importedFile, additionalFilterButtons, onFilterChange, onImportedFile }) => {

    const { t } = useTranslation("core");

    ///
    const getImportMenuItems = useCallback((): MprcDropdownItems<MenuImportOptions> => {
        const groups: MprcDropdownItems<MenuImportOptions>[] = [];

        const group0: MprcDropdownItems<MenuImportOptions> = [
            { text: t("User.SearchUsers.Import.FileAction"), value: "importFile" },
            { text: t("User.SearchUsers.Import.TextAction"), value: "importList" },
        ];

        if (importedFile) {
            group0.push({ text: t("User.SearchUsers.Import.ClearAction"), value: "clear" });
        }

        groups.push(group0);

        return MprcDropdownBuildGroupedItems<MenuImportOptions>(groups);

    }, [importedFile]);

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <MprcCardFilterBox>
            <AdvancedFilter
                filter={filterOptions}
                leftDropdowns={[{
                    filterCommands,
                    title: t("shared:AdvFilter.Title"),
                    textOrIcon: <IconFilter />
                }]}
                rightDropdowns={[]}
                leftDropdownAlign="end"
                startComponent={
                    <Typography variant="h3">{t("User.SearchUsers.Title")}</Typography>
                }
                beforeLeftDropdown={[
                    <Box mr={3}>
                        <MprcIconButtonDropdown
                            color={importedFile ? "warning" : "muted"}
                            title={t("User.SearchUsers.ImportUserButtonTitle")}
                            icon={<IconUpload />}
                            onChange={(option) => onImportedFile(option)}
                            items={getImportMenuItems()}
                        />
                    </Box>
                    , ...additionalFilterButtons ?? []
                ]
                }
                onFilterChange={(filter) => onFilterChange({ ...filterOptions, ...filter })}
                onError={error => MprcRequestSnackbarErrorReport(error)}
            />
        </MprcCardFilterBox>
    );
};
